<ts-input-field
  #mapSearchField
  [field]="{
    formControl,
    props: inputFieldProps,
  }"
  (ionBlur)="inputBlur()"
></ts-input-field>
<ts-ion-form-field-validation-message-ui
  [showError]="showError"
  [field]="field"
></ts-ion-form-field-validation-message-ui>

<google-map
  width="100%"
  height="100%"
  [options]="googleMapOptions"
  [ngClass]="getClass()"
>
  @if (markerPosition) {
    <map-marker
      [position]="markerPosition"
      [options]="markerOptions"
    ></map-marker>
  }
</google-map>
